import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({
	title,
	description,
	lang = 'en',
	keywords,
	image,
	schemaMarkup,
}: {
	title: string;
	description?: string;
	lang?: string;
	keywords?: string[];
	image?: string;
	schemaMarkup?: object
}): JSX.Element => {
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						social {
							image
						}
					}
				}
			}
		`
	);

	const metaDescription = description || site.siteMetadata.description;
	const metaImage = image || site.siteMetadata.social.image;

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			meta={[
				{
					name: `description`,
					content: metaDescription,
				},
				{
					property: `og:title`,
					content: title,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					name: `og:image`,
					content: metaImage,
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},
				{
					name: `twitter:title`,
					content: title,
				},
				{
					name: `twitter:image`,
					content: metaImage,
				},
			].concat(
				keywords && keywords.length > 0
					? {
							name: `keywords`,
							content: keywords.join(`, `),
					  }
					: []
			)}
		>
			{schemaMarkup && <script type="application/ld+json" >{JSON.stringify(schemaMarkup)}</script>}
		</Helmet>
	);
};

export default SEO;
